import RequiredMark from '@components/FormFields/RequiredMark';
import { Button, Card, CircularProgress } from '@hyperflake/react-ui-library';
import { FormHelperText, Label } from '@library/forms';
import { ErrorMessage, Form, Formik } from 'formik';
import useLinkAddForm from 'modules/links/hooks/useLinkAddForm';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { FormikInput } from 'modules/shared/features/formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const LinkAddForm = () => {
    const { clientId, projectId } = useParams();
    const navigate = useNavigate();

    const addLinkForm = useLinkAddForm(clientId, projectId);
    const handleSubmit = async (values: any) => {
        try {
            const link = await addLinkForm.submit(values);

            toast.success('Client added successfully');
            navigate(`/clients/${clientId}/projects/${projectId}/links`);
        } catch (err: any) {
            console.log(err);

            toast.error('Oops something went wrong.');
        }
    };
    return (
        <PageTemplate>
            {/* <PageHeading>Add Link</PageHeading> */}

            <Formik
                initialValues={addLinkForm.initialValues}
                enableReinitialize
                validationSchema={addLinkForm.schema}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        {/* Logo and Email header */}
                        <Card className="">
                            <Card.Header>Add Link</Card.Header>
                            <Card.Body>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap:1  md:gap-4">
                                    <div className="col-span-1">
                                        <Label>
                                            Name <RequiredMark />
                                        </Label>
                                        <FormikInput type="text" name="name" />
                                        <FormHelperText variant={'error'}>
                                            <ErrorMessage name="name" />
                                        </FormHelperText>
                                    </div>
                                    <div className=" col-span-2">
                                        <Label>
                                            Url <RequiredMark />
                                        </Label>
                                        <FormikInput type="text" name="url" />
                                        <FormHelperText variant={'error'}>
                                            <ErrorMessage name="url" />
                                        </FormHelperText>
                                    </div>
                                </div>
                                <Button
                                    type="submit"
                                    size={'lg'}
                                    className="mt-4"
                                    disabled={addLinkForm.isSubmitting}
                                    // onClick={() => console.log(values, 'values')}
                                >
                                    {addLinkForm.isSubmitting ? (
                                        <CircularProgress size={20} color={'inherit'} />
                                    ) : (
                                        'Submit'
                                    )}
                                </Button>
                            </Card.Body>
                        </Card>
                    </Form>
                )}
            </Formik>
        </PageTemplate>
    );
};

export default LinkAddForm;
